'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alignSelf = exports.order = exports.alignContent = exports.alignItems = exports.justifyContent = exports.flexFlow = exports.flexWrap = exports.flexDirection = exports.flexGrow = exports.flexShrink = exports.flexBasis = exports.flex = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', ';\n  '], ['\n    ', ';\n  ']);

var _core = require('@emotion/core');

var _ = require('../../');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var flex = exports.flex = function flex(_ref) {
  var flex = _ref.flex;
  return flex && (0, _core.css)(_templateObject, _2.default.responsive('flex')(flex));
};

var flexBasis = exports.flexBasis = function flexBasis(_ref2) {
  var flexBasis = _ref2.flexBasis;
  return flexBasis && (0, _core.css)(_templateObject, _2.default.responsive('flex-basis')(flexBasis));
};

var flexShrink = exports.flexShrink = function flexShrink(_ref3) {
  var flexShrink = _ref3.flexShrink;
  return flexShrink && (0, _core.css)(_templateObject, _2.default.responsive('flex-shrink')(flexShrink));
};

var flexGrow = exports.flexGrow = function flexGrow(_ref4) {
  var flexGrow = _ref4.flexGrow;
  return flexGrow && (0, _core.css)(_templateObject, _2.default.responsive('flex-grow')(flexGrow));
};

var flexDirection = exports.flexDirection = function flexDirection(_ref5) {
  var flexDirection = _ref5.flexDirection;
  return flexDirection && (0, _core.css)(_templateObject, _2.default.responsive('flex-direction')(flexDirection));
};

var flexWrap = exports.flexWrap = function flexWrap(_ref6) {
  var flexWrap = _ref6.flexWrap;
  return flexWrap && (0, _core.css)(_templateObject, _2.default.responsive('flex-wrap')(flexWrap));
};

var flexFlow = exports.flexFlow = function flexFlow(_ref7) {
  var flexFlow = _ref7.flexFlow;
  return flexFlow && (0, _core.css)(_templateObject, _2.default.responsive('flex-flow')(flexFlow));
};

var justifyContent = exports.justifyContent = function justifyContent(_ref8) {
  var justifyContent = _ref8.justifyContent;
  return justifyContent && (0, _core.css)(_templateObject, _2.default.responsive('justify-content')(justifyContent));
};

var alignItems = exports.alignItems = function alignItems(_ref9) {
  var alignItems = _ref9.alignItems;
  return alignItems && (0, _core.css)(_templateObject, _2.default.responsive('align-items')(alignItems));
};

var alignContent = exports.alignContent = function alignContent(_ref10) {
  var alignContent = _ref10.alignContent;
  return alignContent && (0, _core.css)(_templateObject, _2.default.responsive('align-content')(alignContent));
};

var order = exports.order = function order(_ref11) {
  var order = _ref11.order;
  return order && (0, _core.css)(_templateObject, _2.default.responsive('order')(order));
};

var alignSelf = exports.alignSelf = function alignSelf(_ref12) {
  var alignSelf = _ref12.alignSelf;
  return alignSelf && (0, _core.css)(_templateObject, _2.default.responsive('align-self')(alignSelf));
};